module.exports = __webpack_public_path__ + "img/header_background.440ab7d8.png";